// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailNaoVerificadoAlert_wrapper__BnRCY","btnPerfil":"EmailNaoVerificadoAlert_btnPerfil__mzR1C"};